import { z } from 'zod/v4';
import { Brand } from '../branded-types';

export type PaymentProviderId = Brand<string, 'paymentProviderId'>;

export const PAYMENT_PROVIDER_SCHEMA: z.ZodType<IPaymentProvider> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as PaymentProviderId)
    .optional(),
  filename: z.string(),
  fileExtension: z.string(),
});

export const PAYMENT_PROVIDERS_SCHEMA: z.ZodType<IPaymentProvider[]> = z.array(
  PAYMENT_PROVIDER_SCHEMA
);

export interface IPaymentProvider {
  id?: PaymentProviderId;
  filename: string;
  fileExtension: string;
}

export const DEFAULT_PAYMENT_PROVIDERS: IPaymentProvider[] = [
  {
    id: 'b0e01472-7df0-4cb6-bb7c-2b62d26f634b' as PaymentProviderId,
    filename: 'LOGPAY',
    fileExtension: 'svg',
  },
  {
    id: 'c3f68420-5c64-4e78-9e56-11f8072049e2' as PaymentProviderId,
    filename: 'Mastercard',
    fileExtension: 'svg',
  },
  {
    id: 'd7a96e28-1b42-49cf-8927-14ec13c7bb90' as PaymentProviderId,
    filename: 'VISA',
    fileExtension: 'svg',
  },
  {
    id: 'e1c953a4-9213-48e0-94e8-89c0919241b7' as PaymentProviderId,
    filename: 'PayPal',
    fileExtension: 'svg',
  },
];
